import * as React from 'react';

// Components
import Box from '../Box';
import Paper from '../Paper';
import Typography from '../Typography';

// Component
interface IProps {
    headline: string;
    subheading: string;
    icon: string;
    actions?: React.ReactNode | Array<React.ReactNode>;
}

function StatusCard(props: IProps) {
    return (
        <Paper>
            <Box pa={5} align="center">
                <Box pb={4}>
                    <img src={props.icon} width={192} height={192}/>
                </Box>
                <Typography type="headline">{props.headline}</Typography>
                <Typography type="subheading">{props.subheading}</Typography>
                <Box pb={3} />
                {props.actions}
            </Box>
        </Paper>
    );
}

export default StatusCard;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StatusCard/Status.tsx